import { Button, GanttChart, ProGressLine } from 'components';
import { ContainerChangeTime } from 'containers/GranttChart';
import { WorkerShiftConstant } from 'constant';
import { Layout, LayoutProps } from 'containers';
import { useAppDispatch } from 'hooks';
import { dayjs } from 'libs';
import { routes } from 'navigations/routers';
import NewentrantSendoff from 'pages/NewentrantSendoff';
// 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
import EducationStatus from 'pages/EducationStatus';
// 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
import SendPhoto from 'pages/EducationStatus/SendPhoto';
// 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
// 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
import { workerSelector, workShiftSelector } from 'pages/Home/Bo/selectors';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) start
import { userData } from 'pages/Login/selectors';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) end
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQueryParams } from 'hooks';
import { generatePath, Prompt, useHistory, useParams } from 'react-router';
import { userService } from 'services';
import { PostUserSchedulesUpdateParams, WorkerShift } from 'types';
import { groupBy, isArray, isEqual, unionBy, uniqBy, uniqueId, uniqWith } from 'lodash';
import { checkHasDate } from 'containers/TableGantt';
import * as Types from '../../../types';
import ConfirmUpdateSchedule from './ConfirmUpdateSchedule';
import ContactWorker from './ContactWorker';
import SectionStyled from './styles';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) start
// import {
//   getCooperatorSchedules,
//   getUnpropertyListShop as getPropertyListShop,
//   getUserSchedules,
// } from './thunk';
import {
  // 2024/02/27 Leading Win 障害対応 No9 start
  // getCooperatorSchedules,
  // 2024/02/27 Leading Win 障害対応 No9 end
  getUnpropertyListShop as getPropertyListShop,
  getUserSchedules,
  findPropertyInfo,
} from './thunk';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) end
import WorkerShiftTable from './WorkerShiftTable';
import {
  addGanttChartDataCooperator,
  addGanttChartDataUser,
  cooperatorSchedulesData,
  resetSchedules,
} from './slice';

const WorkShift: FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const workerShift = useSelector(workShiftSelector.selectAll);
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) start
  // const { unpropertyListShop } = useSelector(workerSelector);
  const {
    PropertyInfoList,
    // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
    error_message,
    // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
  } = useSelector(workerSelector);
  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  const { user_id, business_owner_flg, syokucyou_flg } = useSelector(userData);
  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) end
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
  // const { entity = WorkerShiftConstant.PLANNED_WORK_SITES } =
  //   useParams<{ entity: WorkerShiftConstant }>();
  const { entity = WorkerShiftConstant.WORKER_SHIFT_TABLES } = useParams<{
    entity: WorkerShiftConstant;
  }>();
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
  const [isModalVisibleModalScheduleConfirmation, setIsModalVisibleModalScheduleConfirmation] =
    useState<boolean>(false);
  const {
    userSchedules,
    cooperatorSchedulesLoading,
    cooperatorSchedules,
    listWorkType,
    listUserSite,
    ganttChartDataUser,
    ganttChartDataCooperator,
  } = useSelector(workerSelector);
  const [isModalVisibleContact, setIsModalVisibleContact] = useState<boolean>(false);
  const [confirmUpdateScheduleLoading, setConfirmUpdateScheduleLoading] = useState<boolean>(false);
  const dataDragEdit = useRef<PostUserSchedulesUpdateParams[]>([]);
  const originDataDragEdit = useRef<WorkerShift[]>([]);
  const [readonly, setReadonly] = useState<boolean>(true);
  const [keyLocation, setKeyLocation] = useState<string>('');
  const query = useQueryParams();
  const currentDate = query.get('currentDate');
  const handleSelectedTab = useCallback(
    (entity) => {
      return history.replace(
        `${generatePath(routes.Home.path, { entity })}?currentDate=${dayjs(
          currentDate ?? undefined
        ).format('YYYY-MM-DD')}`
      );
    },
    [currentDate, history]
  );

  useEffect(() => {
    let cooperatorSchedulesDataResult: WorkerShift[] = [];
    const dataInMonth = cooperatorSchedules.filter((item) => {
      let result = false;
      if (item.schedules && item.schedules.length > 0) {
        item.schedules.map((i) => {
          if (
            dayjs(
              dayjs(currentDate ?? undefined)
                .startOf('month')
                .format('YYYY-MM-DD')
            ).isBetween(i.start_date, i.end_date, 'day', '[)')
          ) {
            result = true;
          }
        });
      }
      return result;
    });

    dataInMonth.map((itemSites) => {
      // ren list work type
      if (!itemSites.schedules.length) {
        return null;
      }
      if (!!itemSites.schedules.length && itemSites.schedules.length > 0) {
        let groupByWorkTypeObject = groupBy([...itemSites.schedules], 'work_type_id');
        const groupByWorkTypeArray = Object.keys(groupByWorkTypeObject).map(
          (key) => groupByWorkTypeObject[key]
        );
        if (!!groupByWorkTypeArray.length && groupByWorkTypeArray.length > 0) {
          groupByWorkTypeArray.map((i, indexI) => {
            cooperatorSchedulesDataResult.unshift({
              id: `${itemSites.building_code}-split-${indexI}`,
              text: itemSites.site_name,
              title_quickinfo: itemSites.site_name,
              work_type_id: itemSites.work_type_id,
              building_id: itemSites.building_id,
              label_Column: i?.[0]?.work_type_name ?? '',
              localeQuickInfo: i?.[0]?.work_type_name ?? '',
              start_date: currentDate
                ? dayjs(currentDate ?? undefined)
                    .startOf('month')
                    .format('YYYY-MM-DD')
                    .toString()
                : '',
              end_date: currentDate
                ? dayjs(currentDate ?? undefined)
                    .endOf('month')
                    .format('YYYY-MM-DD')
                    .toString()
                : '',
              className: '',
              render: 'split',
              isWorktype: true,
              IsEditable: false,
              building_code: itemSites.building_code,
              row_height: 64,
              isScheduleCooperator: true,
            });
            if (!!i.length && i.length > 0) {
              i.map((itemSchedules, index) => {
                cooperatorSchedulesDataResult.unshift({
                  id: `worktype_${itemSchedules.work_type_id}-${index}-${uniqueId()}`,
                  text: itemSites.site_name,
                  title_quickinfo: itemSites?.site_name,
                  work_type_id: itemSchedules.work_type_id,
                  building_id: itemSites.building_id,
                  label_Column: itemSchedules.work_type_name,
                  isChild: true,
                  parent: `${itemSites.building_code}-split-${indexI}`,
                  localeQuickInfo: itemSchedules.work_type_name,
                  start_date:
                    itemSchedules.start_date === 'Invalid Date'
                      ? ''
                      : dayjs(itemSchedules.start_date).format('YYYY-MM-DD'),
                  end_date:
                    itemSchedules.start_date === 'Invalid Date'
                      ? ''
                      : dayjs(itemSchedules.end_date).format('YYYY-MM-DD'),
                  className: checkHasDate({
                    endDate: itemSchedules.end_date,
                    startDate: itemSchedules.start_date,
                  })
                    ? 'primary'
                    : 'disable',
                  isWorktype: true,
                  IsEditable: false,
                  building_code: itemSites.building_code,
                  row_height: 64,
                  isScheduleCooperator: true,
                });
              });
            }
          });
        }
      }
    });
    dispatch(addGanttChartDataCooperator(cooperatorSchedulesDataResult));
  }, [cooperatorSchedules, currentDate, dispatch, query]);

  useEffect(() => {
    // rent list user
    const cooperatorUserSchedulesData: WorkerShift[] = [];
    if (!!listUserSite.length && listUserSite.length > 0) {
      unionBy(listUserSite, 'user_id').map((userItem) => {
        cooperatorUserSchedulesData.push({
          id: `${userItem.user_id}`,
          IsEditable: true,
          text: userItem.user_name,
          isParent: true,
          render: 'split',
          start_date: currentDate
            ? dayjs(currentDate ?? undefined)
                .startOf('month')
                .format('YYYY-MM-DD')
                .toString()
            : '',
          end_date: currentDate
            ? dayjs(currentDate ?? undefined)
                .endOf('month')
                .format('YYYY-MM-DD')
                .toString()
            : '',
          infoMore: {
            ...userItem,
          },
          className: '',
          user_id: userItem.user_id,
        });

        const schedulesUser =
          userSchedules && userSchedules.find((item) => item.user_id === userItem.user_id);
        if (schedulesUser && !!schedulesUser.sites.length) {
          schedulesUser.sites.map((itemSites, indexSites) => {
            let scheduleWorkType = listWorkType.find(
              (itemWorkType) => +itemWorkType.work_type_id === +itemSites.work_type_id
            );
            const dataSite = cooperatorSchedules.find(
              (item) => item.building_id == itemSites.building_id
            );
            cooperatorUserSchedulesData.push({
              id: `${userItem.user_id}-${indexSites}`,
              IsEditable: true,
              text: indexSites === 0 ? userItem.user_name : '',
              isParent: indexSites === 0,
              render: 'split',
              className: '',
              user_id: userItem.user_id,
              parentSecondary: true,
              start_date: dayjs(currentDate).format('YYYY-MM-DD'),
              end_date: dayjs(currentDate).format('YYYY-MM-DD'),
              infoMore: {
                ...itemSites,
                ...scheduleWorkType,
                ...userItem,
              },
              parent: indexSites === 0 ? `${userItem.user_id}` : undefined,
              work_type_id: itemSites.work_type_id,
              dateMin: scheduleWorkType?.start_date || '',
              dateMax: scheduleWorkType?.end_date || '',
              building_id:
                itemSites.schedules && itemSites.schedules.length > 0
                  ? itemSites.building_id
                  : undefined,
            });
            itemSites &&
              itemSites.schedules.map((itemSchedules, indexSchedules) => {
                cooperatorUserSchedulesData.push({
                  user_id: userItem.user_id,
                  work_type_id: itemSites.work_type_id,
                  building_id: itemSites.building_id,
                  building_code: itemSites.building_code,
                  label: dataSite?.site_name,
                  text: dataSite?.site_name,
                  locale: itemSites.work_type_name,
                  localeQuickInfo: itemSites.work_type_name,
                  operator: userItem?.user_name,
                  id: `children-${userItem.user_id}-${indexSchedules}-${uniqueId()}`,
                  infoMore: {
                    ...itemSites,
                    ...scheduleWorkType,
                    ...userItem,
                  },
                  IsEditable: true,
                  parent: `${userItem.user_id}-${indexSites}`,
                  start_date: dayjs(itemSchedules.from_date).format('YYYY-MM-DD'),
                  end_date: dayjs(itemSchedules.to_date).format('YYYY-MM-DD'),
                  isChild: true,
                  className: checkHasDate({
                    startDate: itemSchedules.from_date,
                    endDate: dayjs(itemSchedules.to_date).format('YYYY-MM-DD'),
                  })
                    ? 'primary'
                    : 'disable',

                  dateMin: scheduleWorkType?.start_date || '',
                  dateMax: scheduleWorkType?.end_date || '',
                });
              });
          });
        } else {
          cooperatorUserSchedulesData.push({
            id: `${userItem.user_id}-notSchedules`,
            user_id: userItem.user_id,
            building_id: undefined,
            text: userItem.user_name,
            operator: userItem?.user_name,
            IsEditable: true,
            parent: `${userItem.user_id}`,
            start_date: dayjs(currentDate).format('YYYY-MM-DD'),
            end_date: dayjs(currentDate).format('YYYY-MM-DD'),
            isChild: true,
            className: 'hidden',
          });
        }
      });
      dispatch(addGanttChartDataUser(cooperatorUserSchedulesData));
    }
  }, [
    cooperatorSchedules,
    currentDate,
    dispatch,
    listUserSite,
    listWorkType,
    query,
    userSchedules,
  ]);

  useEffect(() => {
    if (ganttChartDataUser && ganttChartDataCooperator) {
      dispatch(cooperatorSchedulesData([...ganttChartDataCooperator, ...ganttChartDataUser]));
    }
  }, [dispatch, ganttChartDataCooperator, ganttChartDataUser]);
  const fetchAPI = useCallback(async () => {
    switch (entity) {
      // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
      // case WorkerShiftConstant.PLANNED_WORK_SITES:
      //   const params = {
      //     from_date: dayjs(currentDate ?? undefined)
      //       .startOf('month')
      //       .format('YYYY-MM-DD'),
      //     to_date: dayjs(currentDate ?? undefined)
      //       .endOf('month')
      //       .format('YYYY-MM-DD'),
      //   };
      //   dispatch(resetSchedules());
      //   currentDate && dispatch && (await dispatch(getUserSchedules(params)));
      //   return;
      // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
      case WorkerShiftConstant.WORKER_SHIFT_TABLES:
        // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) start
        // !unpropertyListShop?.loading &&
        //   unpropertyListShop.sites.length < 1 &&
        //   dispatch(getPropertyListShop(true));
        // 2024/10/18 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
        // !PropertyInfoList?.loading &&
        //   PropertyInfoList.site_data.length < 1 &&
        // 2024/10/18 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
        dispatch(
          findPropertyInfo({
            user_id: `${user_id}`,
            worker_schedules_check_flg: true,
          })
        );
        // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) end
        return;
      default:
        return null;
    }
    // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) start
    // }, [currentDate, dispatch, entity, unpropertyListShop?.loading, unpropertyListShop.sites.length]);
  }, [
    currentDate,
    dispatch,
    entity,
    // 2024/10/18 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
    // PropertyInfoList?.loading,
    // PropertyInfoList.site_data.length,
    // 2024/10/18 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
    user_id,
  ]);
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) end

  // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
  // useEffect(() => {
  //   if (entity == WorkerShiftConstant.PLANNED_WORK_SITES) {
  //     history.replace({
  //       pathname: history.location.pathname,
  //       search: `?currentDate=${dayjs(currentDate ?? undefined).format('YYYY-MM-DD')}`,
  //     });
  //   }
  // }, [currentDate, entity, history, query]);
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 end

  // 2024/02/27 Leading Win 障害対応 No9 start
  // useEffect(() => {
  //   dispatch(getCooperatorSchedules({}));
  // }, [dispatch]);
  // 2024/02/27 Leading Win 障害対応 No9 end

  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
  // useEffect(() => {
  //   if (business_owner_flg === 1 || syokucyou_flg === 1) {
  //     if (!tabs) return;
  //     if (tabs?.length < 3) {
  //       tabs?.push({ label: '新規・送出', key: WorkerShiftConstant.EducationStatus });
  //     }
  //   }
  // }, [dispatch, business_owner_flg, syokucyou_flg, tabs]);
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end

  useEffect(() => {
    fetchAPI();
  }, [fetchAPI]);
  const handleConvertData = useCallback(
    (dataEdit: WorkerShift[]) => {
      let result: PostUserSchedulesUpdateParams[] = [];
      if (!dataEdit) return result;
      const parentIds = uniqWith(
        dataEdit.map((i) => i.parent),
        isEqual
      );

      const allDataRelate = workerShift.filter((item) => parentIds.includes(item.parent));

      const updateAllData = allDataRelate.map((item) => {
        let findIndexItem = dataEdit.findIndex((itemEdit) => itemEdit.id === item.id);

        if (findIndexItem !== -1) {
          return {
            ...item,
            end_date: dayjs(dataEdit[findIndexItem].end_date).add(-1, 'day').format('YYYY-MM-DD'),
            start_date: dataEdit[findIndexItem].start_date,
          };
        }
        return item;
      });
      const newDataPush = updateAllData.map((itemEdit) => {
        let newItem: PostUserSchedulesUpdateParams = {
          building_id: itemEdit?.building_id ?? '',
          work_type_id: itemEdit?.work_type_id ?? '',
          user_id: itemEdit?.user_id ?? '',
          out_of_schedule: 0,
          date: [],
        };
        //  merge()
        if (
          (itemEdit?.dateMin &&
            itemEdit?.dateMax &&
            dayjs(itemEdit?.start_date).unix() > dayjs(itemEdit?.dateMax).unix()) ||
          dayjs(itemEdit?.end_date).unix() < dayjs(itemEdit?.dateMin).unix() ||
          dayjs(itemEdit?.start_date).unix() < dayjs(itemEdit?.dateMin).unix() ||
          dayjs(itemEdit?.end_date).unix() > dayjs(itemEdit?.dateMax).unix()
        ) {
          newItem.out_of_schedule = 1;
        }
        if (isArray(newItem.date) && itemEdit?.start_date && itemEdit?.end_date) {
          newItem.date.push({
            from_date: dayjs(itemEdit?.start_date).format('YYYY-MM-DD'),
            to_date: dayjs(itemEdit?.end_date).format('YYYY-MM-DD'),
          });
        }

        return newItem;
      });

      //merge all data with same parent
      result = uniqWith(newDataPush, (pre, cur) => {
        if (
          pre.building_id === cur.building_id &&
          pre.user_id === cur.user_id &&
          cur.work_type_id === pre.work_type_id &&
          cur.out_of_schedule === pre.out_of_schedule
        ) {
          if (cur.date && pre.date) {
            cur.date = [...pre.date, ...cur.date];
          }
          cur.date = uniqBy(cur.date, 'from_date');
          cur.date = uniqBy(cur.date, 'to_date');
          return true;
        }
        return false;
      });
      return result;
    },
    [workerShift]
  );

  const onAddScheduleUser = useCallback(
    async ({ data }: { data: Types.PostUserSchedulesUpdateParams }) => {
      await userService.postUserSchedulesUpdate({ ...data });
      return dispatch(
        getUserSchedules({
          from_date: dayjs(currentDate ?? undefined)
            .startOf('month')
            .format('YYYY-MM-DD'),
          to_date: dayjs(currentDate ?? undefined)
            .endOf('month')
            .format('YYYY-MM-DD'),
        })
      );
    },
    [currentDate, dispatch]
  );

  const onDelete = useCallback(
    async (itemDelete, callback) => {
      try {
        const getItems = workerShift.filter((item) => item.parent == itemDelete.parent);
        const getData = getItems.filter((item) => item.id !== itemDelete.id);
        const newDate = unionBy(
          getData.map((i) => ({ from_date: i.start_date, to_date: i.end_date })),
          'form_date'
        );
        itemDelete &&
          (await userService.postUserSchedulesUpdate({
            building_id: itemDelete.building_id ?? '',
            work_type_id: itemDelete.work_type_id ?? '',
            user_id: itemDelete.user_id ?? '',
            date: newDate,
            out_of_schedule: 0,
          }));
        await dispatch(
          getUserSchedules({
            from_date: dayjs(currentDate ?? undefined)
              .startOf('month')
              .format('YYYY-MM-DD'),
            to_date: dayjs(currentDate ?? undefined)
              .endOf('month')
              .format('YYYY-MM-DD'),
          })
        );
        callback && callback();
      } catch (e) {
        console.error(e);
      }
    },
    [currentDate, dispatch, workerShift]
  );

  useEffect(() => {
    if (!keyLocation || readonly) {
      return;
    }
    if (keyLocation !== history.location.key) {
      setKeyLocation('');
      setReadonly(true);
    }
  }, [history.location.key, keyLocation, readonly]);

  return (
    <SectionStyled>
      <Prompt
        message={`シフトを登録せずに画面を離れますか？
      画面を離れるとシフトの編集内容は削除されます。
      登録する場合には、キャンセルを選択し、シフトの確定ボタンを押してください。`}
        // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
        // when={
        //   entity === WorkerShiftConstant.PLANNED_WORK_SITES &&
        //   !readonly &&
        //   keyLocation === history.location.key
        // }
        when={
          entity === WorkerShiftConstant.WORKER_SHIFT_TABLES &&
          !readonly &&
          keyLocation === history.location.key
        }
        // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
      />
      <ConfirmUpdateSchedule
        visible={isModalVisibleModalScheduleConfirmation}
        loading={confirmUpdateScheduleLoading}
        onOK={async () => {
          const convertData = dataDragEdit.current;
          setConfirmUpdateScheduleLoading(true);
          try {
            convertData?.length > 0 &&
              (await Promise.all(
                convertData?.map((request) => userService.postUserSchedulesUpdate(request))
              ));

            originDataDragEdit.current = [];
            await dispatch(
              getUserSchedules({
                from_date: dayjs(currentDate ?? undefined)
                  .startOf('month')
                  .format('YYYY-MM-DD'),
                to_date: dayjs(currentDate ?? undefined)
                  .endOf('month')
                  .format('YYYY-MM-DD'),
              })
            );
            dataDragEdit.current = [];
            setIsModalVisibleModalScheduleConfirmation(false);
            setConfirmUpdateScheduleLoading(false);
            setKeyLocation('');
            setReadonly(true);
          } catch (error) {
            originDataDragEdit.current = [];
            setReadonly(true);
            setIsModalVisibleModalScheduleConfirmation(false);
            setConfirmUpdateScheduleLoading(false);
          }
        }}
        onCancel={() => {
          originDataDragEdit.current = [];
          setIsModalVisibleModalScheduleConfirmation(false);
        }}
      />
      <ContactWorker
        title="連絡事項入力"
        visible={isModalVisibleContact}
        onCancel={() => {
          setIsModalVisibleContact(false);
        }}
      />
      <Layout
        // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
        tabs={
          business_owner_flg === 1 || syokucyou_flg === 1
            ? tabs
            : tabs?.filter((i) => i.key !== WorkerShiftConstant.EducationStatus)
        }
        // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
        onSelected={handleSelectedTab}
        defaultValue={entity}
        left
        right
      />
      {/* 2024/02/19 Leading Win 作業員シフト表廃止対応 start */}
      {/* {entity === WorkerShiftConstant.PLANNED_WORK_SITES && (
        <div className="mt-16 bo-body">
          <div
            className={`top ${
              cooperatorSchedulesLoading ? 'd-none' : 'd-flex'
            } justify-between pl-32 pr-32 mb-8 bo-header`}
          >
            <ContainerChangeTime
              showIconDate
              onChangeDate={(date) => {
                history.replace({
                  pathname: history.location.pathname,
                  search: `?currentDate=${dayjs(date).format('YYYY-MM-DD')}`,
                });
              }}
              currentDateProps={dayjs(currentDate ?? undefined).toDate()}
            />
            <div className="box-button">
              {readonly ? (
                <>
                  <Button
                    size="small"
                    loading={unpropertyListShop.loading}
                    onClick={async () => {
                      await dispatch(getPropertyListShop(true));
                      setIsModalVisibleContact(true);
                    }}
                  >
                    工事担当者へ連絡
                  </Button>
                  <Button
                    size="small"
                    style={{ marginLeft: 16 }}
                    onClick={() => {
                      if (history?.location?.key) {
                        setKeyLocation(history?.location?.key);
                      }
                      setReadonly(false);
                    }}
                  >
                    シフトの編集
                  </Button>
                </>
              ) : (
                <>
                  <Button size="small" onClick={() => setReadonly(true)}>
                    キャンセル
                  </Button>
                  <Button
                    size="small"
                    type="primary"
                    style={{ marginLeft: 16 }}
                    onClick={async () => {
                      try {
                        const convertData = dataDragEdit.current;
                        if (convertData && convertData.length > 0) {
                          const findHasMaxDate = convertData.findIndex(
                            (item) => item.out_of_schedule === 1
                          );
                          if (findHasMaxDate !== -1) {
                            setIsModalVisibleModalScheduleConfirmation(true);
                          } else {
                            await Promise.all(
                              convertData.map((request) =>
                                userService.postUserSchedulesUpdate(request)
                              )
                            ).then(() => {
                              dataDragEdit.current = [];
                              originDataDragEdit.current = [];
                              setReadonly(true);
                            });
                            setKeyLocation('');
                            return dispatch(
                              getUserSchedules({
                                from_date: dayjs(currentDate ?? undefined)
                                  .startOf('month')
                                  .format('YYYY-MM-DD'),
                                to_date: dayjs(currentDate ?? undefined)
                                  .endOf('month')
                                  .format('YYYY-MM-DD'),
                              })
                            );
                          }
                        }
                      } catch (error) {
                        console.error(error);
                      }
                    }}
                  >
                    シフトの確定
                  </Button>
                </>
              )}
            </div>
          </div>
          <div className={'bo-content'} style={{ height: '100%' }}>
            {cooperatorSchedulesLoading && <ProGressLine show={cooperatorSchedulesLoading} />}
            <GanttChart
              width="100%"
              height={cooperatorSchedulesLoading ? '0px' : 'calc(100vh - 114px) !important'}
              autosize={'false'}
              labelColumnSideBarLeft="現場名"
              type={'default'}
              isReadonly={readonly}
              data={workerShift}
              callBackDataDragEdit={(data, originData) => {
                dataDragEdit.current = handleConvertData(data);
                originDataDragEdit.current = originData;
              }}
              onDelete={onDelete}
              onAddScheduleUser={onAddScheduleUser}
              grid_width={244}
              refreshData={async () => {
                dispatch(
                  getUserSchedules({
                    from_date: dayjs(currentDate ?? undefined)
                      .startOf('month')
                      .format('YYYY-MM-DD'),
                    to_date: dayjs(currentDate ?? undefined)
                      .endOf('month')
                      .format('YYYY-MM-DD'),
                  })
                );
              }}
              quick_info
              scale_height={49}
              setIsReadonly={setReadonly}
              currentDate={dayjs(currentDate ?? undefined).toDate()}
            />
          </div>
        </div>
      )} */}
      {/* 2024/02/19 Leading Win 作業員シフト表廃止対応 end */}
      {entity === WorkerShiftConstant.WORKER_SHIFT_TABLES && (
        <WorkerShiftTable
          // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) start
          // dataUnpropertyListShop={unpropertyListShop?.sites}
          // loadingUnpropertyListShop={unpropertyListShop?.loading}
          dataUnpropertyListShop={PropertyInfoList?.site_data}
          loadingUnpropertyListShop={PropertyInfoList?.loading}
          // 2023/10/24 Leading Win 作業員シフト表廃止対応 DXWEBLOS00100_現場一覧(作業予定現場一覧) end
          // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
          error_message={error_message}
          // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
          dataShopSchedules={cooperatorSchedules}
          loadingShopSchedules={cooperatorSchedulesLoading}
        />
      )}
      {entity === WorkerShiftConstant.EducationStatus && <EducationStatus />}
      {entity === WorkerShiftConstant.NEW_ENTRANTSENDOFF && <NewentrantSendoff />}
      {/* 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start */}
      {entity === WorkerShiftConstant.SendPhoto && <SendPhoto />}
      {/* 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end */}
    </SectionStyled>
  );
};
const tabs: LayoutProps['tabs'] = [
  // { label: '作業員シフト表', key: WorkerShiftConstant.PLANNED_WORK_SITES },
  { label: '作業予定現場一覧', key: WorkerShiftConstant.WORKER_SHIFT_TABLES },
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 start
  // 2024/03/28 Leading Win 教育機能の非表示 start
  // { label: '新規・送出', key: WorkerShiftConstant.EducationStatus },
  // 2024/03/28 Leading Win 教育機能の非表示 end
  // 2024/02/19 Leading Win 作業員シフト表廃止対応 end
  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
];

export default WorkShift;
